/// <amd-module name="typeahead/features/HotelFilterForLXCheckout" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

"use strict";

import {IInputElementConfig} from "typeahead/core/ExpediaSuggestServiceRequestGenerator";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, Suggestion} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
       lobs: ["ACTIVITIES"],
    },
];

export class HotelFilterForLXCheckout {

    private readonly applicableClientIds: string[] = ["LX.Checkout"];
    private readonly applicableTextInputElementIds: string[] = ["lx-pickup-uta"];

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IInputElementConfig):
        ISuggestServiceQueryParams {
        /* Verify that the feature is only for LX Checkout */
        if (this.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
              && ExecutionHelper.shouldExecute(context, configuration)
              && this.applicableTextInputElementIds.indexOf(options.inputElementId) > -1) {
                params.rid = options.searchRegionId;
        }
        return params;
    }
}
